var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 6.99804C2.99609 8.52171 4.13769 9.77722 5.60593 9.97185C6.01527 11.8314 7.5748 13.2597 9.50063 13.4726V14.9684H7.50426C6.39969 14.9684 5.50426 15.8638 5.50426 16.9684V17.4684C5.50426 17.7446 5.72811 17.9684 6.00426 17.9684H14.0043C14.2804 17.9684 14.5043 17.7446 14.5043 17.4684V16.9684C14.5043 15.8638 13.6088 14.9684 12.5043 14.9684H10.5006V13.4726C12.4257 13.2599 13.9848 11.8328 14.395 9.97434C15.8629 9.78134 16.9961 8.52535 16.9961 7.0047V5.50006C16.9961 4.67163 16.3245 4.00006 15.4961 4.00006H14.5007C14.4997 2.89636 13.6047 2.00195 12.5007 2.00195H7.50073C6.39679 2.00195 5.50176 2.89636 5.50073 4.00006H4.49609C3.66767 4.00006 2.99609 4.67163 2.99609 5.50006V6.99804ZM4.49609 5.00006H5.50073V8.93434C4.63664 8.71114 3.99609 7.92741 3.99609 6.99804V5.50006C3.99609 5.22392 4.21995 5.00006 4.49609 5.00006ZM14.5007 5.00006H15.4961C15.7722 5.00006 15.9961 5.22392 15.9961 5.50006V7.0047C15.9961 7.93404 15.3608 8.71499 14.5007 8.9369V5.00006ZM13.5007 4.00195V9.00006C13.5007 10.9331 11.9337 12.5001 10.0007 12.5001C8.12004 12.5001 6.5858 11.0167 6.50415 9.15614V4.00006H6.50073C6.50176 3.44865 6.94908 3.00195 7.50073 3.00195H12.5007C13.053 3.00195 13.5007 3.44967 13.5007 4.00195ZM6.50426 16.9684C6.50426 16.4161 6.95197 15.9684 7.50426 15.9684H12.5043C13.0565 15.9684 13.5043 16.4161 13.5043 16.9684H6.50426Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.94ba116e1312fb5e15042564dc62b265.svg";
export { ForwardRef as ReactComponent };